import { AxiosInstance } from 'axios';
import GroupService from './groupService';

export default function useGroup( axiosIns: AxiosInstance, groupOverrideConfig: Object ) {
  const group = new GroupService( axiosIns, groupOverrideConfig )

  return {
    group,
  }
}